import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import login from '../views/pageLogin.vue'
// import login from '../views/Home.vue'
import pageSearch from '../views/pageSearch.vue'
import drugDetail from '../views/drugDetail.vue'
import bookDetail from '../views/bookDetail.vue'
import pageCatalogue from '../views/pageCatalogue.vue'
import pageBook from '../views/pageBook.vue'
import pageArticle from '../views/pageArticle/index.vue'
import articleDetail from '../views/pageArticle/detail.vue'
import personalData from '../views/personalData.vue'
import fortuneTask from '../views/fortuneTask.vue'
import chatGpt from '../views/chatGpt/index.vue'
import tips from '../views/pageTips/pageTips.vue'
import store from '@/store';

Vue.use(VueRouter)

const routes = [
    {
        /* 首先进行重新定向操作 */
        path: '/',
        redirect: {
            name: 'home'
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '*',
        name: 'tips',
        component: tips,
        meta: {
            hideInMenu: true,
            title: '空页',
        }
    },

]

export const routesList = [
    // {
    //     path: '/home',
    //     name: 'home',
    //     component: Home
    // },
    {
        path: '/chatGpt',
        name: 'chatGpt',
        component: chatGpt,
        props: true,
    },
    {
        path: '/pageCatalogue/:bookId/:bookName',
        name: 'pageCatalogue',
        component: pageCatalogue,
        props: true,
    },
    {
        path: '/pageBook/:keyword*',
        name: 'pageBook',
        component: pageBook,
        props: true,
    },
    {
        path: '/bookDetail/:bookId/:id/:bookName/:keyword*',
        name: 'bookDetail',
        component: bookDetail,
        props: true,
    },
    {
        path: '/drugDetail/:drugName',
        name: 'drugDetail',
        component: drugDetail,
        props: true,
    },
    {
        path: '/pageSearch/:keyword*',
        name: 'pageSearch',
        component: pageSearch,
        props: true,
    },
    {
        path: '/pageArticle/:keyword*',
        name: 'pageArticle',
        component: pageArticle,
        props: true,
    },
    {
        path: '/articleDetail/:articleId',
        name: 'articleDetail',
        component: articleDetail,
        props: true,
    },
    {
        path: '/personalData/:keyword*',
        name: 'personalData',
        component: personalData,
        props: true,
    },
    {
        path: '/fortuneTask/:keyword*',
        name: 'fortuneTask',
        component: fortuneTask,
        props: true,
    },
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (store.getters.isShow && !['/', '/login'].includes(to.fullPath)) {
        localStorage.setItem("fullPath2", to.fullPath)
    }
    if (to.name == 'bookDetail' && from.name == 'pageBook') {
        store.commit("besideRoll")  //目录滚动定位
    }
    if (to.name == "home") {
        next();
    }else if (!store.getters.token && to.name != "login") {
        next("/login");
    } else if (store.getters.token && to.name == "login") {
        next(false);
    } else {
        next();
    }
})

export default router